import { HttpRequest } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';

export const INTERCEPTOR_EXCEPT_URL: string[] = [
  API_ENDPOINT.token.loginStaff,
  API_ENDPOINT.token.loginAdmin,
  API_ENDPOINT.token.loginStaffModule,
  API_ENDPOINT.token.loginMasterModule,
  API_ENDPOINT.token.loginAdminModule,
  '/assets/i18n/',
];

export const AUTH_TOKEN_INTERCEPTOR_FILTER =
  new InjectionToken<(req: HttpRequest<any>) => boolean>('Interceptor Filter');
